import { useSelector } from 'react-redux';
import useRagFlowId from './useRagFlowId';

export default function useRagRetrieverId() {
  const ragFlowId = useRagFlowId();

  return useSelector((state: any) => {
    const { flowNodes } = state.entities;
    const ragFlowNode = flowNodes[ragFlowId];

    // keep going down the tree until we find the retriever node
    let retrieverNode = ragFlowNode;

    while (retrieverNode && retrieverNode.node_type !== 'data_retriever_holder') {
      retrieverNode = flowNodes[retrieverNode.children[0]];
    }

    return retrieverNode?.data_set_id;
  });
}
